import styled from '@emotion/styled';
import { IconAndTextButtonLink } from '@blueprint/ui';
import { css } from '@emotion/css';
import { ButtonLinkWithIcon, Text } from '@blueprint/ui';
import { LSRP_SIDEBAR_MEDIA_QUERY } from '../common/constants';

type MobileAlertPanelWrapperProps = {
    justifyContent?: 'space-evenly' | 'left';
};

export const MobileAlertPanelWrapper = styled(
    'div'
)<MobileAlertPanelWrapperProps>(
    ({ theme, justifyContent = 'space-evenly' }) => css`
        display: flex;
        padding-top: 1.125rem;
        padding-bottom: 0.7rem;
        justify-content: ${justifyContent};
        background-color: ${theme.colors['graphic-background']};
        width: 100%;
        margin-top: -1.5rem;

        ${LSRP_SIDEBAR_MEDIA_QUERY} {
            display: none;
        }
    `
);

export const MobileText = styled(Text)(
    ({ theme }) => css`
        display: inline;
        ${theme.mq.small} {
            display: none;
        }
    `
);
export const TabletText = styled(Text)(
    ({ theme }) => css`
        display: none;
        ${theme.mq.small} {
            display: inline;
        }
    `
);

export const AlertPanelButtonLinkMobile = styled(IconAndTextButtonLink)(
    () => css`
        border: 0;
        display: flex;
    `
);

export const SaveEditSearchButton = styled(ButtonLinkWithIcon)(
    () => css`
        padding-left: 0;
    `
);

export const Divider = styled('span')(
    ({ theme }) => css`
        width: 0.0625rem;
        height: 2rem;
        background-color: ${theme.colors['graphic-divider']};
        display: inline-block;
    `
);
